/* unplugin-vue-components disabled */import script from "./OrderItemsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderItemsCard.vue?vue&type=script&setup=true&lang=js"

import "./OrderItemsCard.vue?vue&type=style&index=0&id=4b4a9786&lang=scss"

const __exports__ = script;

export default __exports__